<template>
  <div class="hello page_repeat">
      <!-- <div class="formTop page-chart">
    <div class="topNav">
      <ShowNavHead/>
      <div class="dateSelect"></div>
      <div class="remindListTopRight" style="margin-right:24px">
        <div style="margin-right:10px">搜索</div>
        <div class="topInput">
            <el-input v-model.trim="remindQuery.strempname" placeholder="请输入项目名称、姓名或身份证号码" @keyup.enter.native="searchEnterFun"></el-input>
          </div>
      </div>
    </div>
    </div> -->
    <remindListTop @event3="change3($event)" @transformVal="getVal"  @fatherMethod="getremindlist"></remindListTop>
      <!-- <repeat v-if="isHandled==0"></repeat>
      <repeatProcessed v-if="isHandled==1"></repeatProcessed> -->
      <div class="main-con">
        <div class="crumbs">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>通知</el-breadcrumb-item>
            <el-breadcrumb-item>待办事项</el-breadcrumb-item>
            <el-breadcrumb-item>重复入职提醒</el-breadcrumb-item>
            <el-breadcrumb-item>
              <span>同公司多次入职</span>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="idCardTable">
          <el-table :data="tableData"  :max-height="tableHeight-180" style="width: 99%" stripe v-loading='listLoading'>
            <!-- <el-table-column align="center" type="selection" width="50px"></el-table-column> -->
            <el-table-column align="center" label="序号" width="50">
              <template slot-scope="{$index}">
              <span>{{(Number(remindQuery.currpage) - 1) * Number(remindQuery.pagecount) + Number($index) + 1}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="项目名称" min-width="10%" fit :show-overflow-tooltip="true">
              <template slot-scope="{row}">
                <span>{{row.StrObjName}}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column align="center" label="档案号" prop="StrFileNo" min-width="10%"></el-table-column> -->
            <el-table-column align="center" label="姓名" min-width="10%" fit :show-overflow-tooltip="true">
              <template slot-scope="{row}">
                <span>{{row.StrEmpName}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="身份证号码" min-width="18%" fit :show-overflow-tooltip="true">
              <template slot-scope="{row}">
                <span>{{row.StrIdCard}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="重复入职次数" min-width="10%" fit :show-overflow-tooltip="true">
              <template slot-scope="{row}">
                <span style="color: #F78500;">{{row.doublecount}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" fixed="right" label="操作" min-width="16%">
              <template slot-scope="{row}">
                <button class="changeServe" style="margin-right:10px" @click="seeDetail(row)">查看详情</button>
              </template>
            </el-table-column>
          </el-table>
          <div class="block" v-show="totalcount>0">
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage3"
                :page-size="pagecount"
                @size-change="handleSizeChange"
                :page-sizes="[10, 20, 50, 100]"
                layout="total,sizes,prev,pager, next, jumper"
                :total="this.totalcount"
              ></el-pagination>
          </div>
        </div>
    </div>
     <el-dialog :title="dtlUserName+'入职详情'" :visible.sync="dialogVisible" width="870px" >
        <el-table :data="detailData" style="width: 99%" stripe v-loading='dtlLoading'>
            <el-table-column align="center" label="序号" width="50px">
              <template slot-scope="{$index}">
              <span>{{Number($index) + 1}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="项目名称" min-width="130px">
              <template slot-scope="{row}">
                <span>{{row.StrObjName}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="档案号" min-width="100px">
              <template slot-scope="{row}">
                <span>{{row.StrFileNo}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="姓名">
              <template slot-scope="{row}">
                <span>{{row.StrEmpName}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="身份证号码" min-width="150px">
              <template slot-scope="{row}">
                <span>{{row.StrIdCard}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="合同（协议）类型" min-width="120px">
              <template slot-scope="{row}">
                <span>{{row.StrContractType}}</span>
              </template>
            </el-table-column>
             <el-table-column align="center" label="用工之日" min-width="90px">
              <template slot-scope="{row}">
                <span>{{!isNull(row.DtEntryBdate)?row.DtEntryBdate.substring(0,10):''}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="工作状态">
              <template slot-scope="{row}">
                <span style="color: #F78500;">{{row.StrWorkState}}</span>
              </template>
            </el-table-column>
          </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="dialogVisible = false" type="primary">关闭</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
import xz from "./../../common";
import remindListTop from "./components/remindListTop.vue";
export default {
  components: {
    remindListTop
  },
  data () {
    return {
      tableHeight:0,
      dtlLoading:false,
      dialogVisible:false,
      //详情列表数据
      detailData:[],
      listLoading:false,
      isHandled:0,
      currpage:1,
      // status:0,
      totalcount:0,
      currentPage3: 1,
      strempname:'',
      remindQuery : {
        tableid:"XZ_emp_UserBase",
        pagecount:10,
        currpage:1,
        content:'doubleadd',
        strstatus:"0", //已处理/未处理
        strempname:""
      },
      pagecount:10,
      tableData: [],
      dtlUserName:''
    }
  },
  created(){
    this.calHeight();
    this.getremindlist();
  },
  methods : {
    //判断是否为空(包含0)
    isNull(o) {
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == '1900/01/01' || o == '1900-01-01T00:00:00' || o == '1900-01-01';
    },
    calHeight(){
      this.tableHeight = Number(document.body.clientHeight);
      console.log('height',this.tableHeight) 
    },
    //分页转跳
    handleCurrentChange(val) {
      this.remindQuery.currpage = `${val}`;
      this.getremindlist();
    },
    handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.remindQuery.pagecount = `${val}`;
        this.getremindlist();
    },
    searchEnterFun(){
      this.getremindlist();
    },
    seeDetail(item) {
      this.dialogVisible = true
      this.dtlLoading = true
      this.detailData = item.data
      this.dtlUserName = item.StrEmpName
      this.dtlLoading = false
    },
    change3(data) {
      console.log('datas',data)
      this.isHandled = data;
      this.remindQuery.strstatus = data
      this.remindQuery.currpage = 1
      this.remindQuery.content = 'doubleadd'
    },
    getVal(data){
      // console.log('名称',data)
      this.remindQuery.strempname = data
    },
    //获取待办事项列表
    getremindlist(){
      this.tableData = []
      this.listLoading = true
      xz.getremindlist(this.remindQuery).then(res=>{
        console.log('待办事项列表',res)
        if(res){
          if(res.dateall && res.dateall.length>0){
          this.tableData = res.dateall;
          this.totalcount = parseInt(res.totalcount);
          }else{
            this.tableData = []
            this.totalcount = 0
          }
        }
        this.listLoading = false
      })
    }
  }
}
</script>
<style>
 .page_repeat .textBox{
     width: 220px;
   }
</style>
